angular.module('filters')
    .filter('filterState', () => (states, query) => {

        if (angular.isUndefined(query) || !query) {

            return states;

        }
        return _.filter(states, (state) => {

            if (!state.name) {

                return false;

            }
            return (state.name.toLowerCase().indexOf(query.toLowerCase()) === 0);

        });

    });



// WEBPACK FOOTER //
// ./scripts/filters/filterState.js